var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"toggle"},[_c('label',{staticClass:"toggle__label"},[_vm._v(_vm._s(this.label))]),_c('VSwitchButton',{attrs:{"checked":this.checked},on:{"click":_vm.onClick}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }